import {
	Component,
	Input,
	OnDestroy,
	OnInit,
	Output,
	EventEmitter
} from '@angular/core';
import { Subscription } from 'rxjs';
import { KngLoader, KngLoaderState } from './definitions';
import { KngLoaderService } from './kng-loader.service';

@Component({
	selector: 'kng-loader',
	templateUrl: './template/kng-loader.component.html',
	styleUrls: ['./template/kng-loader.component.scss']
})
export class KngLoaderComponent implements KngLoader, OnInit, OnDestroy 
{
	private subscriptions: Subscription = new Subscription();

  @Input() set state(value: KngLoaderState) 
	{
		this.service.updateState(value);
	}
  get state(): KngLoaderState 
  {
  	return this.service.state;
  }

  @Output() stateChanged: EventEmitter<KngLoaderState> =
  	new EventEmitter<KngLoaderState>();

  constructor(private service: KngLoaderService) {}

  ngOnInit(): void 
  {
  	this.initSubscriptions();
  }
  ngOnDestroy(): void 
  {
  	this.destroySubscriptions();
  }

  private initSubscriptions(): void 
  {
  	const stateChangeSubs: Subscription = this.service.stateChanged.subscribe(
  		(next: KngLoaderState) => this.stateChanged.emit(next)
  	);
  	this.subscriptions.add(stateChangeSubs);
  }
  private destroySubscriptions(): void 
  {
  	this.subscriptions.unsubscribe();
  }
}
